import {Injectable, OnInit} from "@angular/core";

@Injectable()
export abstract class ComponentBase implements OnInit {
  ngOnInit(): void {
    this.preload(() => {
      this.load();
    })
  }

  protected preload(callback?: () => void) {
    if (callback !== undefined) callback();
  };

  protected load() {

  };
}
